import { marketplaceDisplayName } from 'ui/Strategies/config';
import HoveMessagedBasedOnType from './HoveMessagedBasedOnType';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { isCrypto } = ApplicationDomainUtility;

const oneIndentation = '';

export const getContentList = (isPremium, historicRunLimit, liveRunLimit) => {
  return [
    {
      id: 'calendarSpread',
      content: <>Calendar Spread</>,
      isChecked: isPremium,
    },
    {
      id: 'strikeMultiplierAndAddCases',
      content: <>Strike Multiplier and Add cases</>,
      isChecked: isPremium,
    },
    {
      id: 'customAdjustment',
      content: <>Adjustment Features</>,
      isChecked: isPremium,
    },
    {
      id: 'marketPlacePremiumStrategyDeploy',
      content: (
        <>
          <b>Exclusive Premium</b>
          {oneIndentation}
          {marketplaceDisplayName}
        </>
      ),
      isChecked: isPremium,
    },
    {
      id: 'backTestCredits',
      content: (
        <div className="d-flex align-items-center">
          <b className="me-1">{historicRunLimit}</b>
          {oneIndentation}
          Backtest Credits
          <HoveMessagedBasedOnType type="backTestCredits" />
        </div>
      ),
      isChecked: true,
    },
    {
      id: 'liveDeploymentCredits',
      content: (
        <div className="d-flex align-items-center">
          <b className="me-1">{liveRunLimit}</b>
          Live Deployment Credits
          <HoveMessagedBasedOnType type="liveDeploymentCredits" />
        </div>
      ),
      isChecked: true,
    },
  ];
};

export const getProContentList = (isPro, historicRunLimit, liveRunLimit) => {
  return [
    ...(!isCrypto
      ? [{
      id: 'optionBasketFeature',
      content: <>Options Basket Features</>,
      isChecked: isPro,
    },
    {
      id: 'ExclusiveFor1000Users',
      content: <>Exclusive For 1000 Users Only</>,
      isChecked: isPro,
        }]
      : []),
    {
      id: 'exclusivePremiumSupport',
      content: <>Exclusive Premium Support</>,
      isChecked: isPro,
    },
    {
      id: 'marketPlacePremiumStrategyDeploy',
      content: <>Exclusive Live Trading Session & Webinar</>,
      isChecked: isPro,
    },
    {
      id: 'backTestCredits',
      content: (
        <div className="d-flex align-items-center">
          <b className="me-1">{historicRunLimit}</b>
          {oneIndentation}
          Backtest Credits
          <HoveMessagedBasedOnType type="backTestCredits" />
        </div>
      ),
      isChecked: true,
    },
    {
      id: 'liveDeploymentCredits',
      content: (
        <div className="d-flex align-items-center">
          <b className="me-1">{liveRunLimit}</b>
          Live Deployment Credits
          <HoveMessagedBasedOnType type="liveDeploymentCredits" />
        </div>
      ),
      isChecked: true,
    },
  ];
};
